import { Description, Form as FormComponent, Title } from "@/ui";
import clsx from "classnames";
import { Container } from "react-bootstrap";

export const Form = ({ className, title, description, form, bgColor, titleColor, textColor }) => {

  return (
    <div className={clsx(className, `bg-${bgColor}`)}>
      <Container>
        <div>
          <Title title={title} className={clsx(`text-${titleColor}`)} />
          <Description description={description} className={clsx(`text-${textColor}`)} />
          <FormComponent formId={form} />
        </div>
      </Container>
    </div>
  );
};

export default Form;